import { gql } from '@apollo/client';

export const ChangeProfilePassword = gql`
    mutation changeProfilePassword($currentPassword: String!, $newPassword1: String!, $newPassword2: String!) {
        changeProfilePassword(
            currentPassword: $currentPassword
            newPassword1: $newPassword1
            newPassword2: $newPassword2
        ) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
